import { render } from "./DialogEntrancePlantCreateStep4.vue?vue&type=template&id=33d3fd7c&ts=true"
import script from "./DialogEntrancePlantCreateStep4.ts?vue&type=script&lang=ts"
export * from "./DialogEntrancePlantCreateStep4.ts?vue&type=script&lang=ts"

import "./DialogEntrancePlantCreateStep4.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/home/vsts/work/1/s/Frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__